<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/apppointsdetails/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            buttonName="调账"
            addShowPower="/apppointsdetails/tiaozhang"
            @openAddDialog="openDialog"
            buttonType="warning"
        >
            <el-form-item label="用户ID">
                <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="商户号">
                <el-input v-model="formModel.merNo" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="订单号">
                <el-input v-model="formModel.orderNo" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="机具SN号">
                <el-input v-model="formModel.sn" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="积分类型">
                <el-select v-model="formModel.bigType">
                    <el-option
                        v-for="item in bigType"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="账户类型">
                <el-select v-model="formModel.acctType">
                    <el-option
                        v-for="item in acctType"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="交易类型">
                <el-select v-model="formModel.type">
                    <el-option
                        v-for="item in operationType"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="操作类型">
                <el-select v-model="formModel.operationDirection">
                    <el-option
                        v-for="item in operationDirection"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="userId"
                label="用户ID"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="userPhone"
                label="用户手机号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="userName"
                label="用户名称"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="acctType"
                label="账户类型"
                :formatter="formatterTableacctType"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merName"
                label="商户名称"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merNo"
                label="商户号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merPhone"
                label="商户手机号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="orderNo"
                label="订单号"
                min-width="260"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                prop="sn"
                label="SN号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="bigType"
                label="商户积分类型"
                min-width="120"
                show-overflow-tooltip
                :formatter="formatterTablebigType"
            ></el-table-column>
            <el-table-column
                prop="type"
                label="交易类型"
                min-width="120"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                prop="operationDirection"
                label="操作类型"
                min-width="120"
                show-overflow-tooltip
                :formatter="formatterTableoperationDirection"
            ></el-table-column>
            <el-table-column
                prop="number"
                label="积分数量"
                min-width="120"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                prop="balNumber"
                label="剩余数量"
                min-width="120"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                prop="remark"
                label="备注"
                min-width="120"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                fixed="right"
                prop="createTime"
                label="创建时间"
                min-width="160"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                fixed="right"
                prop="modifier"
                label="操作人"
                min-width="160"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
        </common-table>
        <form-dialog
            ref="formDialog"
            formDialogTitle="调账"
            :model="dialogModel"
            :submitData="dialogData"
            :rules="dialogRules"
            :dialogService="dialogService"
            @close="dialogClose"
            @success="dialogSuccess"
        >

            <el-form-item label="账户类型" prop="acctType">
                <el-select v-model="dialogModel.acctType">
                    <el-option
                        placeholder="请选择"
                        v-for="item in acctType.slice(1, acctType.length)"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="积分类型" prop="bigType">
                <el-select v-model="dialogModel.bigType">
                    <el-option
                        placeholder="请选择"
                        v-for="item in shanghuTypes.slice(1, shanghuTypes.length)"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="交易类型" prop="operation">
                <el-select v-model="dialogModel.operation">
                    <el-option
                        placeholder="请选择"
                        v-for="item in operationType.slice(1, operationType.length)"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label-width="90px" prop="operationDirection">
                <el-radio-group v-model="dialogModel.operationDirection">
                    <el-radio :label="1">加</el-radio>
                    <el-radio :label="2">减</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="商户编号" prop="memId">
                <el-input
                    type="textarea"
                    v-model="dialogModel.memId"
                    rows="5"
                    placeholder="请输入，多个‘,’分割"
                ></el-input>
            </el-form-item>
            <el-form-item label="调账积分" prop="adjustAmt">
                <el-input-number
                    placeholder="请输入"
                    v-model="dialogModel.adjustAmt"
                    :controls="false"
                    controls-position="right"
                    :precision="0"
                    :step="1"
                    :min="0"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="备注" prop="remark" style="width: 360px">
                <el-input
                    maxlength="300"
                    show-word-limit
                    type="textarea"
                    resize="none"
                    rows="5"
                    placeholder="请输入备注"
                    v-model="dialogModel.remark"
                ></el-input>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import LYFAcctTypes from "service/constant/LYFAcctTypes";
    import FormDialog from "@/view/dialog/FormDialog";
    import TransactionService from "service/TransactionService";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "apppointsdetails",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,
        },
        data() {
            return {
                formModel: {
                    merNo: "",
                    acctType: "",
                    userId: "",
                    orderNo: "",
                    sn: "",
                    type: "",
                    time: "",
                    operationDirection: "",
                    bigType: "",
                },
                operationType: [
                    {
                        dictKey: "",
                        dictValue: "全部",
                    },
                ],
                bigType: [
                    {
                        dictKey: "",
                        dictValue: "全部",
                    },
                ],
                operationDirection: [
                    {
                        dictKey: "",
                        dictValue: "全部",
                    },
                    {
                        dictKey: "1",
                        dictValue: "加",
                    },
                    {
                        dictKey: "2",
                        dictValue: "减",
                    },
                ],
                tableData: [],
                submitService: TransactionService.apppointsdetailsList,
                params: {},
                page: {},
                isPage: false,
                dialogModel: {
                    bigType: "",
                    operation: "",
                    acctType: "",
                    adjustAmt: undefined,
                    memId: "",
                    remark: "",
                    operationDirection: 1,
                },
                dialogRules: {
                    operation: [
                        {
                            required: true,
                            message: "请选择",
                        },
                    ],
                    bigType: [
                        {
                            required: true,
                            message: "请选择",
                        },
                    ],
                    acctType: [
                        {
                            required: true,
                            message: "请选择",
                        },
                    ],
                    memId: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    adjustAmt: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    remark: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                },
                dialogService: TransactionService.merchantinfoAdjust,
                shanghuTypes: [{
                    dictKey: '',
                    dictValue: '全部'
                },{
                    dictKey: '1',
                    dictValue: '消费积分'
                },{
                    dictKey: '2',
                    dictValue: '签到积分'
                },],
                acctType: LYFAcctTypes
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.getTypeNames("积分类型", (res) => {
                this.operationType = [...this.operationType, ...res];
            });
            this.getTypeNames("商户积分类型", (res) => {
                this.bigType = [...this.bigType, ...res];
            });
            this.load();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == "") {
                    this.formModel.time = [];
                }
                const params = {
                    acctType: this.formModel.acctType,
                    userId: this.formModel.userId,
                    merNo: this.formModel.merNo,
                    orderNo: this.formModel.orderNo,
                    sn: this.formModel.sn,
                    type: this.formModel.type,
                    operationDirection: this.formModel.operationDirection,
                    bigType: this.formModel.bigType,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length) {
                    params.startDate = this.formModel.time[0];
                    params.endDate = this.formModel.time[1];
                }
                return params;
            },
            dialogData() {
                const params = {
                    operation: this.dialogModel.operation,
                    bigType: this.dialogModel.bigType,
                    acctType: this.dialogModel.acctType,
                    adjustAmt: this.dialogModel.adjustAmt,
                    remark: this.dialogModel.remark,
                    merNo: this.dialogModel.memId,
                    operationDirection: this.dialogModel.operationDirection,
                };
                return params;
            },
            ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
        },
        methods: {
            load() {
                this.formModel = {
                    acctType: "",
                    merNo: "",
                    userId: "",
                    orderNo: "",
                    sn: "",
                    type: "",
                    time: "",
                    operationDirection: "",
                    bigType: "",
                };
                this.page = this.$refs.commonTable.page;
                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            formatterTableoperationDirection(row, column, cellValue, index) {
                let value = "--";
                this.operationDirection.forEach((item) => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value;
            },
            formatterTablebigType(row, column, cellValue, index) {
                let value = "--";
                this.bigType.forEach((item) => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value;
            },
            formatterTableoperationType(row, column, cellValue, index) {
                let value = "--";
                this.operationType.forEach((item) => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value;
            },
            openDialog() {
                this.$refs.formDialog.open();
            },
            dialogClose() {
                this.dialogModel = {
                    adjustType: "",
                    operation: "",
                    acctType: "",
                    adjustAmt: undefined,
                    memId: "",
                    remark: "",
                    operationDirection: 1,
                };
            },
            dialogSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
                this.$refs.formDialog.closeDialog();
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/AppPointsDetails.vue